/**
 * IKeys — служебные константы wf.client (порт ru.esoft.wf.client.constants.IKeys).
 */
export const IKeys = {
  /** Принудительный выход из системы (system WS event). */
  $LOGOUT: ':logout',
  /** Логаут после смены пароля учётной записи. */
  CHANGE_PASSWORD_LOGOUT: 'change-password-logout',
  /** Статус присутствия пользователя (online / away / offline). */
  $USER_STATE: ':user-state',
  /** Обновление набора игнорируемых menu-item для blink-нотификаций. */
  $TOGGLE_MENU_NOTIFICATIONS: ':ignore_menu_notifications',
  /** Выделить узел меню без выполнения action. */
  $REQUEST_FOCUS: ':requestFocus',
} as const

export default IKeys
